import { render, staticRenderFns } from "./Massage.vue?vue&type=template&id=253a822b&scoped=true&"
import script from "./Massage.vue?vue&type=script&lang=js&"
export * from "./Massage.vue?vue&type=script&lang=js&"
import style0 from "./Massage.vue?vue&type=style&index=0&id=253a822b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253a822b",
  null
  
)

export default component.exports